import {createTypes, async} from 'redux-action-creator'

export default createTypes(
  [
    'SELECT_DATE',
    ...async('GET_UNAVAILABLE_DATES'),
    'SELECT_TIMESLOT',
    ...async('GET_TIMESLOTS'),
    ...async('MODIFY_TRANSACTION'),
  ],
  'DEPOSIT_V2/TIMESLOT/',
)



// WEBPACK FOOTER //
// ./src/sections/depositV2/types/calendar.js